<div class="tax_exempt">
  <div class="taxContainer">
    <div class="tax-benefit">
      <div class="taxt-container">
        <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax benefit ribbon" />
      </div>
    </div>
  </div>
  <span class="tooltipText">80G Tax Exemption Certificate Available</span>
</div>